"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderElement = exports.CardContainer = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const styles_1 = require("../styles");
const StyledFunctions_1 = require("../helpers/StyledFunctions");
const Flex_1 = tslib_1.__importDefault(require("./Elements/Flex"));
exports.CardContainer = (0, styled_components_1.default)(Flex_1.default) `
  border-radius: 3px;
  border: 1px solid ${styles_1.Colors.Border};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);
`;
const CardHeader = (0, styled_components_1.default)(Flex_1.default) `
  width: 100%;
  border-bottom: 1px solid ${styles_1.Colors.Border};
  padding: 0.5rem;
`;
const CardContent = (0, styled_components_1.default)(Flex_1.default) `
  width: 100%;
`;
const CardFooter = (0, styled_components_1.default)(Flex_1.default) `
  width: 100%;
  border-top: 1px solid ${styles_1.Colors.Border};
`;
const renderElement = (element, defaultElement = null) => {
    const elementType = typeof element;
    switch (elementType) {
        case 'function':
            return element();
        case 'object':
            return element;
        default:
            return defaultElement;
    }
};
exports.renderElement = renderElement;
const Card = ({ children, header, footer, flexDirection, ...restProps }) => {
    const { paddings, margins, rest } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    const renderHeader = (0, exports.renderElement)(header, react_1.default.createElement(CardHeader, null, header));
    const renderFooter = (0, exports.renderElement)(footer, react_1.default.createElement(CardFooter, null, footer));
    return (react_1.default.createElement(exports.CardContainer, { ...margins, ...rest },
        header && renderHeader,
        react_1.default.createElement(CardContent, { ...paddings, flexDirection: flexDirection }, children),
        footer && renderFooter));
};
Card.defaultProps = {
    flexDirection: 'column',
};
exports.default = Card;
